import React from 'react';
import connect from 'react-redux/es/connect/connect';

import translations from '../assets/i18n';
import redux from '../redux.js'

import epaJson from '../assets/epas';
import epaJsonEn from '../assets/epas_en'
import epaJsonUa from '../assets/epas_ua'

const Trans = ({ code, children, lang, substitutions }) => {
  if (!code && !children) {
    console.warn('Empty trans component')
    return null
  }

  if (typeof children === 'string' || !!children.props) {
    children = [children]
  }

  const key = code || getKeyFromChildren(children)
  let translation = translations[lang] && translations[lang][key]
  if (!translation && !substitutions) {
    if (lang !== 'de') {
      console.error('Missing translation for lang', lang, key)
    }
    if (lang === 'de' && (!children)) {
      console.error('Missing translation for de', lang, code)
    }
    return <>{children || code}</>
  }

  if (substitutions) {
    if (lang === 'de' && !translation) {
      translation = substitutePlaceholders(getKeyFromChildren(children), substitutions)
    } else {
      translation = substitutePlaceholders(translation || key, substitutions)
    }
  }

  return mapTranslationToChildren(translation, children)
}

const getKeyFromChildren = children => {
  let compCounter = 0
  let key = ''
  for (const child of children) {
    if (typeof child === 'string') {
      key += child
    } else {
      if (typeof child.props.children === 'string') {
        key += `<${compCounter}>${child.props.children}</${compCounter}>`
      } else {
        key += `<${compCounter}/>`
      }
      compCounter++
    }
  }
  return key
}

/**
 *
 * @param {string} translation
 * @param {any[]} children
 * @returns
 */
const mapTranslationToChildren = (translation, children) => {
  const translationComponents = splitTranslation(translation)
  return children.map((child, idx) => {
    if (typeof child === 'string') {
      if (child.includes('Neue')) {
        console.log({children, child, t: translationComponents[idx]})
      }
      return translationComponents[idx]
    }
    return {
      ...child,
      props: {
        ...child.props,
        children: translationComponents[idx]
      }
    }
  })
}

const splitTranslation = translation => {
  const regex = /<(\d+)>(.*?)<\/\1>|<(\d+)\/>/g;
  let result = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(translation)) !== null) {
    // Push the part of the string before the current match
    if (match.index > 0) {
      result.push(translation.slice(lastIndex, match.index));
    }

    // Push the content inside the tags or undefined for self-closing tags
    result.push(match[2]);

    // Update last index position
    lastIndex = match.index + match[0].length;
  }
  result.push(translation.slice(lastIndex));
  return result
}

const mapStateToProps = ({ user }) => ({
  lang: user.lang,
})

export function t (key, substitutions) {
  const lang = redux.store.getState().user.lang
  return _t(lang, key, substitutions)
}

export function _t (lang, key, substitutions) {
  const translation = translations[lang] && translations[lang][key]
  if (!translation && lang !== 'de') {
    console.error('Missing translation for lang', lang, key)
  }
  if (substitutions) {
    return substitutePlaceholders(translation || key, substitutions)
  }
  return translation || key
}

export function useTranslation (lang) {
  // const lang = useSelector(state => state.user.lang)
  return (key, substitutions) => _t(lang, key, substitutions)
}

const substitutePlaceholders = (template, values) => template.replace(/\$(\d+)/g, (match, index) => values[index] !== undefined ? values[index] : match);


export function getEpas (lang) {
  lang = lang || redux.store.getState().user.lang
  if (lang === 'en') {
    return epaJsonEn
  }
  if (lang === 'ua') {
    return epaJsonUa
  }
  return epaJson
}

export function getEpa (id) {
  const epas = getEpas()
  return epas.find(epa => epa.id === id)
}

export default connect(
  mapStateToProps,
)(Trans)